import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { CurrentUser } from '../general/modules/user/currentUser';
import { ConsentSources } from '../constants/ConsentSources';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import { EmailConsentStates } from '../domains/valueObject/EmailConsentStates';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export type GetConsentStateRequest = {
    token: string,
    suid: string
}

export type GetConsentStateResponse = {
    consent: EmailConsentStates,
    email: string | null
};

export default class ConsentState {
    public setState(state: boolean, email: string, source: ConsentSources) {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        const entryPoint = currentUser.getEntryPoint();

        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();
        const hubApi = getHubApi();

        return isHubApiEnabled
            ? hubApi.setConsentState(window.app.deviceIdentifier, {
                consent: state,
                source: source,
                email: email,
                entryPoint: entryPoint,
                suid: suid,
                token: token
            })
            : HubJsonRpcRequest.makeRequest(
                HubApiMethods.SET_CONSENT_STATE,
                {
                    consent: state,
                    source: source,
                    email: email,
                    entryPoint: entryPoint,
                    suid: suid,
                    token: token
                },
                window.app.deviceIdentifier
            );
    }

    public async getConsentState(): Promise<GetConsentStateResponse> {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();

        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();
        const hubApi = getHubApi();

        if (!isHubApiEnabled) {
            const getConsentState: GetConsentStateResponse|CustomJrpcErrResult = await HubJsonRpcRequest.makeRequest<GetConsentStateResponse, GetConsentStateRequest>(
                HubApiMethods.GET_CONSENT_STATE,
                {
                    token: token,
                    suid: suid
                },
                window.app.deviceIdentifier
            );

            if ('error' in getConsentState) {
                throw new Error(getConsentState.error.message);
            }

            return getConsentState;
        }

        return await hubApi.getConsentState(window.app.deviceIdentifier, {
            suid: suid,
            token: token
        }) as GetConsentStateResponse;
    }
}
